module["exports"] = {
  "descriptor": [
    "Главен",
    "Генерален",
    "Корпоративен",
    "Државен",
    "Регионален",
    "Окружен",
    "Централен",
    "Глобален",
    "Меѓународен"
  ],
  "level": [
    "програмски",
    "истражен",
    "маркетиншки",
    "интеграциски",
    "операциски",
    "комуникациски",
    "креативен",
    "кориснички"
  ],
  "job": [
    "директор",
    "соработник",
    "управител",
    "инженер",
    "специјалист",
    "координатор",
    "администратор",
    "архитект",
    "аналитичар",
    "дизајнер",
    "техничар",
    "консултант",
    "помошник",
    "агент",
    "застапник"
  ]
};
